export default __webpack_public_path__ + "static/media/twitter-icon.343e55cc.svg";